import { MonthPickerWrapper } from "./month-picker-styles";
import UI from "@mile-meeting/mile-ui";
import styled from "@emotion/styled";
import DatePicker from "react-datepicker";

const MonthPicker = ({
  selectedDate,
  onChangeDate,
}: { 
  selectedDate: Date; 
  onChangeDate?: (date: Date) => void;
}) => {
  return <MonthPickerWrapper>
    <DatePicker
      maxDate={new Date()}
      showMonthYearPicker
      selected={selectedDate}
      onChange={(date: Date) => onChangeDate?.(date)}
      locale={"ko"}
      customInput={
        <div>
          <UI.Input
            width={140}
            prefixIcon="calendar"
            showPrefixIcon
            size="small"
            value={`${selectedDate.getFullYear()}년 ${selectedDate.getMonth() + 1}월`}
          />
        </div>
      }
      renderCustomHeader={({ date, decreaseYear, increaseYear }) => (
        <MonthPickerHeader>
          <div onClick={decreaseYear}>
            <UI.Icon name="arrowLeft" size={20} color="var(--alias-color-label-alternative)" />
          </div>
          <UI.Typography type="body01 normal" fontStyle="bold" color="var(--alias-color-label-normal)">
            {date.getFullYear()}년
          </UI.Typography>
          <div onClick={increaseYear}>
            <UI.Icon name="arrowRight" size={20} color="var(--alias-color-label-alternative)" />
          </div>
        </MonthPickerHeader>
      )}
    />
  </MonthPickerWrapper>;
}

export default MonthPicker;

export const MonthPickerHeader = styled.div`
  background-color: white;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
